// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f7d972a8","453":"c2467dc2","455":"b90b2bb7","977":"9106fa77"}[chunkId] + ".chunk.js";
};